import { FilterPaper } from "@/components/page/FilterPaper";
import { Box, Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";
import type { ReactNode } from "react";

type Props = {
	title: string;
	description?: ReactNode;
	filters?: ReactNode;
	sx?: SxProps<Theme>;
	children: ReactNode;
};

// Shared shell of the Configuration pages: the title sits at the same spot on every page and the
// filters get their own Paper above the content, as on Work Orders
export const ConfigurationPage = ({
	title,
	description,
	filters,
	sx,
	children,
}: Props) => (
	<Box
		sx={[
			{ display: "flex", flexDirection: "column", gap: 2, padding: 1 },
			...(Array.isArray(sx) ? sx : [sx]),
		]}
	>
		<Box sx={{ flexShrink: 0 }}>
			<Typography variant="h5" sx={{ fontWeight: 600, margin: 0 }}>
				{title}
			</Typography>
			{description && (
				<Typography variant="body2" sx={{ color: "text.secondary" }}>
					{description}
				</Typography>
			)}
		</Box>
		{filters && <FilterPaper sx={{ flexShrink: 0 }}>{filters}</FilterPaper>}
		{children}
	</Box>
);
